<template>
  <section class="slide-4 mb-25 w-screen">
    <projectsSlider
        :slides-container-classes="'mb-5'"
        :slider-classes="''"
        :similar-slides="true"
        :pagination="true"
        :projects="text.projects"
        pagination-container-classes="gap-5"
        class="mb-12.5"
    >
      <template v-slot:slides>
        <div
            class="slider-slide project-slide w-screen flex flex-col"
            v-for="(item, index) in projectsText.projects"
            :class="{'active-slide': index === 0}"
            :key="index"
        >
          <img :src="require('@/assets/images/projects/' + item.id + '/' + item.preview + '-m.png')" class="client-list-item w-screen" alt="">
          <h5 class="mt-7.5 mb-2.5 pl-4.5 fz-22 relative" style=" line-height: 1.36;">{{ item.name }}</h5>
          <p class="fz-16 font-medium w-70 text-white pl-4.5" style="line-height: 1.5625;" >{{ item.description }}</p>
        </div>
      </template>
      <template v-slot:pagination>
        <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
      </template>
    </projectsSlider>
    <a href="#mobile-start" class="all-projects flex justify-end items-center mr-4.5" @click="setRoute('projects')">
      <p class="uppercase fz-13 font-semibold mr-5" style="line-height: 1;">{{ text.all }}</p>
      <div class="plus relative w-12.5 h-12.5 rounded-full" style="background:#fff;" >
        <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
        <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
      </div>
    </a>
  </section>
</template>

<script>
import projectsSlider from "@/components/mobile/reuseable/projectsSlider";
import {mapMutations, mapState} from "vuex";


export default {
  name: "slide4",
  components:{
    projectsSlider
  },
  methods:{
    ...mapMutations(['setRoute', 'setProject'])
  },
  computed: {
    text() {
      return require("@/assets/text/projects/slide2/" + this.lang + ".json");
    },
    projectsText(){
      return require("@/assets/text/project/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
}
</script>

<style scoped lang="scss">
.pagination {
  transition: all linear 0.3s;
  background: #fff;
}
.pagination > div > * {
  transition: all linear 0.3s;
}
.pagination .active {
  width: 2.5rem;
  height: 0.25rem;
  background: rgba(255, 46, 83, 1);
}
.project-slide{
  h5,p{
    transition: all linear 0.3s;
  }
  h5{
    left: -3rem;
    color: #6E758D;
    min-height: 1.875rem;
    font-size: 0.9375rem;
  }
  p{
    opacity: 0;
  }
}
.project-slide.active-slide{
  h5{
    left: 0;
    color: #FF2E53;
    font-size: 1.375rem;
  }
  p{
    opacity: 1;
  }
}
</style>
